import { useCallback, useRef } from "react";

/**
 * Throttles the refetch a failed image asks for.
 *
 * Signed media URLs expire after five minutes, so a broken `<img>` usually just
 * needs fresh ones. But if the asset is genuinely gone, every refetch hands back
 * another url that also fails, and refetch-on-error becomes an infinite loop
 * against the API. One attempt per cooldown fixes the expiry case and bounds the
 * other one.
 */
export function useMediaRefresh(refetch: () => void, cooldownMs = 30_000): () => void {
  const lastRun = useRef(0);
  return useCallback(() => {
    const now = Date.now();
    if (now - lastRun.current < cooldownMs) return;
    lastRun.current = now;
    refetch();
  }, [refetch, cooldownMs]);
}
